import React from 'react';
import { Button, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Document} from "../../../types";

export interface DocumentDetailsActionProps {
    document: Document;
    onDetails: (documentId: string) => void;
}

const DocumentDetailsAction: React.FC<DocumentDetailsActionProps> = ({ document, onDetails }) => (
    <Tooltip title="Подробнее">
        <Button
            shape="circle"
            icon={<InfoCircleOutlined />}
            onClick={() => onDetails(document.id)}
        />
    </Tooltip>
);

export default DocumentDetailsAction;
